import { Component, OnInit , Inject,ViewChild, ViewChildren, ElementRef, AfterViewInit, HostListener, Renderer2, Input, OnChanges, ChangeDetectorRef, QueryList } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as _ from 'underscore';


@Component({
  selector: 'app-safetyevent',
  templateUrl: './safetyevent.component.html',
  styleUrls: ['./safetyevent.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ display : 'none',height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed, void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SafetyeventComponent implements OnInit {

  @Input() safetyEventData : any;

  activeSafetyEventVehicle = null;
  safetyEventTblDataSource :any = [];
  safetyEventColumns : string[] = ['sortBase', 'vehicleType', 'year', 'make', 'model', 'totalEvents', 'totalEventPer1K', 'sum_TotalMiles'];
  safetyEventEmbedColumns : string[] = ['categoryType', 'sum_TotalNumberOfEvents', 'countPer1K'];
  @ViewChild('sortSafetyEvent') sortSafetyEvent: MatSort;
  @ViewChild('paginatorSafetyEvent') paginatorSafetyEvent: MatPaginator;

  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;


  expandedElement: any | null;

  
  


  constructor(private render : Renderer2,
     private cd : ChangeDetectorRef,
     private dialog : MatDialog
  ) { }

  generateSafetyEventTable() {
    

    if(!this.safetyEventData) return;
    //sum up harshEventData for the table

    let safetyEvents = this.safetyEventData;

     //for sorting on contional VIN or Vehicleid 
     safetyEvents.forEach((item) => {
      item.sortBase = item.vin && item.vin !== 'N/A' ? item.vin.replace(item.vin.slice(0, (item.vin.length) - 6), "").toString() +'/' : '/' + item.vehicleId
    });

   
    let grouped = _.toArray(_.groupBy(safetyEvents, g => g.vehicleId));

    let safetyEventGeneral = [];

    grouped.forEach((item) => {
    
      safetyEventGeneral.push(
       {
        sortBase :  item[0].sortBase,
        vehicleId : item[0].vehicleId,
        vin : item[0].vin,
        year : item[0].vehicleYear,
        make : item[0].vehicleMake,
        model : item[0].vehicleModel,
        vehicleType : item[0].vehicleType,
        totalEvents : item.reduce((acc, val) =>  val.sum_TotalNumberOfEvents + acc, 0),

        sum_TotalMiles : item[0].sum_TotalMiles,

        totalEventPer1K : item.reduce((acc, val) =>  val.sum_TotalNumberOfEvents + acc, 0) / 1000,

        embededDetails : new MatTableDataSource(item)

      });
    });

    let safetyEventViewData = _.toArray(safetyEventGeneral);
    this.safetyEventTblDataSource = new MatTableDataSource(safetyEventViewData);
    this.safetyEventTblDataSource.sort = this.sortSafetyEvent;
    this.safetyEventTblDataSource.paginator = this.paginatorSafetyEvent;
  }

  toggleRow(element: any) {

    if(element.embededDetails && (element.embededDetails as MatTableDataSource<any>).data.length)
      {
        this.expandedElement = this.expandedElement == element ? null : element;
      }


    this.cd.detectChanges();
    
    this.innerTables.forEach((table, index) => 
    {
      //sort on derived columns
      (table.dataSource as MatTableDataSource<any>).sortingDataAccessor = (item : any, property) => {
        switch (property) {
          case 'countPer1K':
            return item.sum_TotalNumberOfEvents;
         
          default:
            return item[property];
          }
        };
        //sort on derived columns

      (table.dataSource as MatTableDataSource<any>).sort = this.innerSort.toArray()[index];
    })

  }

  openFleetOverview() {
    
    let dialogRef = this.dialog.open(FleetOverviewComponent, {
      data: this.safetyEventData,
      width: '20%',
      //height: '35%',
      id: 'modal-component', //to match the global css
      position: { 
        top: '1%',
        left :'40%',
        right: ''
      }
    }); 


  }



  ngOnInit(): void {

  }

  ngOnChanges(): void
  {
    this.generateSafetyEventTable();
  }
}

@Component({
  selector: 'app-fleet-overview',
  templateUrl: './fleet-overview.html',
  styleUrls: ['./fleet-overview.css'],
})
export class FleetOverviewComponent {

  safetyEventFleet : Array<any> = [];

  constructor(public dialogRef: MatDialogRef<FleetOverviewComponent>,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    ) {}
  

  close() {
    this.dialogRef.close();
  }

  ngOnInit() : void
  {
    if(this.modalData)
    {
      const safetyeventData =  this.modalData;

      const grouped = _.toArray(_.groupBy(safetyeventData, g => g.categoryType));

      grouped.forEach((item) => {
      
        this.safetyEventFleet.push(
        {
          categoryType :  item[0].categoryType,

          totalEvents : item.reduce((acc, val) =>  val.sum_TotalNumberOfEvents + acc, 0),
        });
      });
    }
  }
}
